import moment from 'moment'

export default () => ({
  isLoading: false,
  isLoadingError: false,
  isLoadingMore: false,
  isLoadingMoreBlocked: false,
  isControls: false,
  activePreset: 'future',
  isEditFormActive: false,
  collection: [],
  hasError: false,
  form: {
    dateSort: 'ascending',
    filters: {
      dateFrom: moment().format('DD.MM.YYYY'),
      dateTo: moment().add(6, 'month').format('DD.MM.YYYY'),
      locations: [],
      types: []
    }
  },
  formErrors: [],
  editFormModal: {
    active: false,
    isLoading: false,
    message: null
  },
  editForm: {
    id: null,
    typeId: 1,
    name: null,
    description: null,
    city: null,
    dateFrom: moment().add(3, 'days').format('DD.MM.YYYY'),
    dateTo: moment().add(7, 'days').format('DD.MM.YYYY'),
    time: '12:00',
    price: null,
    status: 1,
    program: null,
    bitrixUserId: null,
    report: null
  },
  editFormErrors: [],
  participationFormModal: {
    active: false,
    isLoading: false,
    header: null,
    showPassportForm: false
  },
  participationForm: {
    id: null,
    name: null,
    surname: null,
    post: null,
    agencyName: null,
    city: null,
    inn: null,
    phone: null,
    email: null,
    foreignPassport: {
      name: null,
      surname: null,
      birthday: null,
      number: null,
      expirationDate: null
    }
  },
  participationFormErrors: [],
  programModal: {
    active: false,
    isLoading: false,
    header: null,
  },
  responsibleUsers: [],
  filtersCollection: {
    date: [],
    locations: []
  },
  dictionaries: {
    eventsTypes: []
  },
  pagination: {
    page: 1,
    perPage: 10,
    lastPage: 1,
    total: 10
  }
})